<template>
  <div
    v-if="pntProfile"
    class=""
  >
    <v-card class="content elevation-1">
      <v-card-text class="pa-2">
        <v-layout
          align-center
          class="ma-0"
        >
          <v-avatar
            v-if="isSeq"
            size="30"
            color="#09234B"
            class="pa-1 mr-2"
          >
            <svg
              class="svg-icon"
              aria-hidden="true"
            >
              <use xlink:href="#iconhaizhenkuai" />
            </svg>
          </v-avatar>
          <v-avatar
            v-else
            size="30"
            color="rgba(76, 175, 80, 0.22)"
            class="pa-1 mr-2"
          >
            <i
              class="iconfont iconchuan green--text"
            />
          </v-avatar>
          <div>
            累計積分：
          </div>
          <!-- <b
            style="font-size: 30px;color:#604626"
            class="pb-2"
          >
            {{ Number(pntProfile.jypointBalance || 0) }}
          </b> -->
          <b class="red--text">
            積分統計中（12/12前完成統計）
          </b>
        </v-layout>

        <v-layout
          row
          class="ma-0"
        >
          <v-flex
            v-for="(v,k,i) in pntProfile.statsMonthly"
            :key="k"
            xs2
            class="text-xs-center pa-1 nowrap"
          >
            <div class=" white back--text border-radius5">
              <!-- {{ i }} -->
              <div class="grey--text">
                {{ k | dateFormat('MMMM') }}
              </div>
              <v-divider />
              <b
                v-if="v>0"
                class="black--text"
              >+{{ Number(v) }}</b>
              <b
                v-else-if="v<0 || [9,10,11].includes(i)"
                class="red--text"
              >
                {{ v == 0 ? '-0' : Number(v) }}
              </b>
              <b v-else>0</b>
            </div>
          </v-flex>
        </v-layout>
      </v-card-text>
    </v-card>
  </div>
</template>
<script>
import dayjs from 'dayjs'
export default {
  data () {
    return {
    }
  },
  computed: {
    isSeq () {
      return this.$route.query.type === 'seq'
    },
    pntProfile () {
      return this.$store.state.coin.jypoint.pntProfile
    },
  },
  mounted () {
    this.fetchData()
  },
  methods: {
    async fetchData () {
      try {
        await this.$store.dispatch('coin/jypoint/profile', {
          dateStart: dayjs().format('YYYY-02-01')
        })
      } finally {

      }
    },
  },
}
</script>
<style lang="postcss" scoped>
.content {
  background: linear-gradient(45deg, #F4E9C5, #F2CC9E);
}
</style>
